import { useState } from 'react';
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { db } from '../../../firebase/firebase.config';
import { updateDoc, doc } from 'firebase/firestore';

export function usePortfolioImageUpload({ ownerId, docId, onUrlUpdate }) {
    const [uploading, setUploading] = useState({ avatar: false, header: false });
    const storage = getStorage();

    // Helper to upload and update Firestore
    const uploadImage = async (file, type) => {
        console.log(`[ImageUpload] Starting ${type} upload`, { file: file?.name, ownerId, docId });
        if (!file || !ownerId || !docId) {
            console.error(`[ImageUpload] Missing required data: file=${!!file}, ownerId=${ownerId}, docId=${docId}`);
            return;
        }
        if (!file.type.startsWith('image/')) {
            console.warn(`[ImageUpload] Invalid file type: ${file.type}`);
            return;
        }
        setUploading(u => ({ ...u, [type]: true }));
        try {
            const ext = file.name.split('.').pop() || 'jpg';
            const storagePath = `portfolioImages/${ownerId}/${type}.${ext}`;
            const storageRef = ref(storage, storagePath);
            console.log(`[ImageUpload] Uploading to Storage: ${storagePath}`);
            await uploadBytes(storageRef, file);
            console.log(`[ImageUpload] Upload complete, fetching download URL`);
            const url = await getDownloadURL(storageRef);
            console.log(`[ImageUpload] Download URL obtained: ${url.substring(0, 50)}...`);
            // Save URL in Firestore
            console.log(`[ImageUpload] Updating Firestore document ${docId}, field: ${type}Image`);
            await updateDoc(doc(db, 'portfolioPages', docId), {
                [`${type}Image`]: url,
            });
            console.log(`[ImageUpload] Firestore update complete`);
            if (onUrlUpdate) onUrlUpdate(type, url);
        } catch (e) {
            console.error(`[ImageUpload] Error: ${e.code || 'unknown'} - ${e.message}`, e);
        } finally {
            setUploading(u => ({ ...u, [type]: false }));
        }
    };

    return {
        uploading,
        uploadAvatar: file => uploadImage(file, 'avatar'),
        uploadHeader: file => uploadImage(file, 'header'),
    };
}
